<template>
  <div class="row">
    <div class="col-12">
        <button @click="seeAll()" class="btn btn-sm btn-primary">
            <i class="fa fa-eye"></i>
            تمت رؤية الكل
        </button><br><br>
        <div class="csard card-bodsy bordesr">
            <div class="col-12 table-responsive">
                <table class="table table-hover bg-white table-bordered table-ssm">
                    <thead>
                        <th>
                            العنوان
                        </th>
                        <th>
                            التاريخ
                        </th>
                        <th>
                            خيارات
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="post in posts" :key="post._id" :class="!post.isSeen ? 'bg-light-warning' : ''">
                            <td>
                                <strong class="text-dark">{{ post.title }}</strong>
                            </td> 
                            <td>
                                {{ post.date }}
                            </td>
                            <td>
                                <button v-b-modal.post class="btn btn-primary btn-sm" @click="current = post; see(post._id)">
                                    <i class="fa fa-eye"></i>
                                    عرض التفاصيل
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <b-modal id="post" title="التفاصيل" hide-footer size="lg">
        <h4>
            {{ current.title }}
        </h4>
        <div v-html="current.content.replace(`oembed url=`, `iframe style='width: 100%; height: 400px' src=`).replace(`watch?v=`, 'embed/')"></div>
    </b-modal>
  </div>
</template>

<script>
import { VBModal, BModal, BFormCheckbox } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BFormCheckbox, BModal
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
    data(){
        return {
            posts: [],
            current: {content: ""},
            user: JSON.parse(localStorage.getItem('user')),
        }
    },
    created(){
        var g = this;
        g.gett()
    },
    methods: {
        gett(){
            var g = this;
            $.post(api + '/user/general/posts', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.posts = r.response
                }
            }).fail(function(){
                alert("حدث خطأ")
                g.loading = false
            })
        },
        seeAll(){
            var g = this;
            $.post(api + '/user/general/show-posts', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.gett()
                }
            }).fail(function(){
                alert("حدث خطأ")
                g.loading = false
            })
        },
        see(id){
            var g = this;
            $.post(api + '/user/general/show-posts-single', {
                jwt: this.user.jwt,
                id: id
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response, 200)
                }else{
                    g.gett()
                }
            }).fail(function(){
                alert("حدث خطأ")
                g.loading = false
            })
        }
    }
}
</script>

<style>

</style>